export const LOGIN_LOCAL_STORAGE_KEY = "ARCHIVOS_LOGIN";
export const REMEMBER_ME_LOCAL_STORAGE_KEY = "ARCHIVOS_REMEMBER_ME";
export const SESSION_STORAGE_ACTIVE_KEY = "ARCHIVOS_SESSION_ACTIVE"
export const SESSION_STORAGE_JWT_TOKEN = "ARCHIVOS_SESSION_JWT_TOKEN"